import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveRemindersFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.remindersSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.remindersFilters]);
    },
  });
};
